import React, { useEffect,  useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import ColourDropDownFIlter from "../../../../components/FilterBox/ColourFilter/ColourDropDownFIlter";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import ColourTable from "../../../../components/Tables/ColourTable";
import Cookies from "js-cookie";
import { FiMenu } from "react-icons/fi";
import {
  ColourFilter,
  ProdGrpMachineWise,
  ProdGrpMachineWiseFun,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import { format } from "date-fns";
import { useTheme } from "../../../../Themecontext/Themecontext";

export const MachineGroupBatchCosting = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, ProdGrpMachineWisedata } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const [showFilter, setShowFilter] = useState(false);

  const monthList = [
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
  ];

  // 🔷 Machine List
  const productionGroupList = ColourfilterData?.ProductionGroup?.map(
    (item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    }),
  );

  const machineGroupList = ColourfilterData?.MachineGroup?.map((item) => ({
    label: item?.MachineGroupMstName,
    value: item?.MachineGroupMstID,
  }));
  // 🔷 States
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonthId, setSelectedMonthId] = useState("");

  const [selectedMachineGroup, setselectedMachineGroup] = useState([]);
  const [selectedMachineGroupId, setSelectedMachineGroupId] = useState([]);

  const [selectedProductionGroup, setSelectProductionGroup] = useState([]);
  const [selectedProductionGroupId, setSelectedProductonGroupId] = useState([]);

  const [filter, setFilter] = useState({
    month: [],
    machineGroup: [],
    productionGroup: [],
  });

  const [search, setSearch] = useState({
    month: "",
    machineGroup: "",
    productionGroup: "",
  });

  useEffect(() => {
    dispatch(ColourFilter());
    dispatch(ProdGrpMachineWise({ FirmIDs: Firm, AcYearIDs: FinancialYear }));
  }, [dispatch, FinancialYear, Firm]);

  const selectedYearObj = DataMain?.AC_Year_List?.find(
    (y) => String(y.AcYearID) === String(FinancialYear),
  );

  const parseAcYear = (acYearStr) => {
    if (!acYearStr) return null;

    const [start, end] = acYearStr.split(" - ");

    const formatDate = (d) => {
      const [dd, mm, yyyy] = d.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  };

  const financialYearRange = parseAcYear(selectedYearObj?.AcYear);

  const FinYearStart = financialYearRange?.start;
  const FinYearEnd = financialYearRange?.end;

  const getMonthId = (monthValue) => {
    if (!FinYearStart || !FinYearEnd) return "";

    const startYear = new Date(FinYearStart).getFullYear();
    const endYear = new Date(FinYearEnd).getFullYear();

    // Jan–Mar → next year
    const year = Number(monthValue) <= 3 ? endYear : startYear;

    return `${year}${monthValue}`; // ex: 202404
  };

  // 🔷 Toggle
  const toggleItem = (type, item) => {
    setFilter((prev) => {
      // Month => Single Select
      if (type === "month") {
        return {
          ...prev,
          month: prev.month.includes(item.value)
            ? []
            : [item.value],
        };
      }

      // Baaki sab => Multi Select
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const TableChartColumns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Machine",
      key: "MachineName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Qty", key: "Quantity", align: "right", format: "true" },
    { label: "Qty %", key: "QuantityPct", align: "right", format: "true" },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    { label: "Meter %", key: "MeterPct", align: "right", format: "true" },
    { label: "Cost Amount", key: "CostAmount", align: "right", format: "true" },
    { label: "Cost %", key: "CostAmountPct", align: "right", format: "true" },
    {
      label: "Cost / Meter",
      key: "CostPerMeter",
      align: "right",
      format: "true",
    },
    { label: "Cost / Qty", key: "CostPerQty", align: "right", format: "true" },
    { label: "Batches", key: "NoOfBatches", align: "right", format: "true" },
    { label: "Taka", key: "Taka", align: "right", format: "true" },
    { label: "Taka %", key: "TakaPct", align: "right", format: "true" },
  ];

  const TableChartRow = (ProdGrpMachineWisedata?.Detail || []).map((row) => ({
    // Machine Name
    MachineName: row?.MachineMstName ?? "",

    // Quantity
    Quantity: row?.Qty ?? 0,
    QuantityPct: row?.QtyPct ?? 0,

    // Meter
    Meter: row?.Meter ?? 0,
    MeterPct: row?.MeterPct ?? 0,

    // Cost
    CostAmount: row?.CostAmount ?? 0,
    CostAmountPct: row?.CostAmountPct ?? 0,

    // Per Unit Cost
    CostPerMeter: row?.PMeterCost ?? 0,
    CostPerQty: row?.PQtyCost ?? 0,

    // Batch / Taka
    NoOfBatches: row?.NoBatches ?? 0,
    Taka: row?.Taka ?? 0,
    TakaPct: row?.TakaPct ?? 0,

    // Extra
    TotalMachines: row?.TotalMachines ?? 0,
  }));

  const handleSubmit = () => {
    dispatch(ProdGrpMachineWiseFun());
    const payload = {
      FirmIDs: Firm,
      AcYearIDs: FinancialYear,
      ProductionGroupIDs: filter.productionGroup.join(","),
      MachineGroupMstIDs: filter.machineGroup.join(","),
    };

    if (filter.month) {
      payload.monthIds = getMonthId(filter.month);
    }

    console.log(filter.month);


    dispatch(ProdGrpMachineWise(payload));
  };




  const handleSubmit1 = () => {
    dispatch(ProdGrpMachineWiseFun());
    const payload = {
      FirmIDs: Firm,
      AcYearIDs: FinancialYear,
      ProductionGroupIDs: selectedProductionGroupId.join(","),
      MachineGroupMstIDs: selectedMachineGroupId.join(","),
    };

    if (selectedMonthId) {
      payload.monthIds = getMonthId(selectedMonthId);
    }

    dispatch(ProdGrpMachineWise(payload));
  };

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ProdGrpMachineWisedata || ProdGrpMachineWisedata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >


      {/* 🔷 MOBILE BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>

      {/* 🔷 OFFCANVAS FILTER */}
      <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}>

            <ColourFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filter.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}

            />

            <ColourFilterBox
              title="Production Group"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filter.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() => selectAll("productionGroup", productionGroupList)}
            />
            <ColourFilterBox
              title="Machine"
              items={machineGroupList}
              search={search.machineGroup}
              setSearch={(val) => handleSearch("machineGroup", val)}
              selectedItems={filter.machineGroup}
              toggleItem={(item) => toggleItem("machineGroup", item)}
              selectAll={() => selectAll("machineGroup", machineGroupList)}
            />
            <button
              onClick={handleSubmit}
              style={{
                height: "48px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                width: "100%",
                borderRadius: "10px",
                fontWeight: "700",
                border: "none",
                padding: "12px"
              }}
            >
              Apply Filter
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* 🔷 DESKTOP FILTER */}
      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour1,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="g-3 align-items-end">
          {/* Month */}
          <Col lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Month"
              data={monthList}
              selectedValue={selectedMonth}
              setSelectedValue={setSelectedMonth}
              selectedId={selectedMonthId}
              setSelectedId={setSelectedMonthId}
              placeholder="Select Month"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
              isMulti={false}
            />
          </Col>

          {/* Batch */}
          <Col lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Production Group"
              data={productionGroupList}
              selectedValue={selectedProductionGroup}
              setSelectedValue={setSelectProductionGroup}
              selectedId={selectedProductionGroupId}
              setSelectedId={setSelectedProductonGroupId}
              placeholder="Select ProductonGroup"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Machine */}
          <Col lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Machine Group"
              data={machineGroupList}
              selectedValue={selectedMachineGroup}
              setSelectedValue={setselectedMachineGroup}
              selectedId={selectedMachineGroupId}
              setSelectedId={setSelectedMachineGroupId}
              placeholder="Select Machine"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Button */}
          <Col lg={6} xl={3}>
            <button
              onClick={handleSubmit1}
              style={{
                height: "48px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                width: "100%",
                borderRadius: "10px",
                fontWeight: "700",
                border: "none",
                padding: "12px"
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      {/* 🔷 TABLE */}
      <div
        style={{
          marginTop: "20px",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "12px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          BATCH COSTING
        </div>

        <ColourTable columns={TableChartColumns} data={TableChartRow} />
      </div>
    </div>
  );
};
